export default __webpack_public_path__ + "static/gary-becigneul-81913afcb156460fa4bdc944afd444dd.png";